import React, { Component } from "react";
import { bool } from "prop-types";
import MdDown from "react-icons/lib/md/keyboard-arrow-down";
import "./AccordionItem.css";

class AccordionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };

    this.onHeaderClick = this.onHeaderClick.bind(this);
  }

  static PropTypes = {
    expanded: bool
  };

  onHeaderClick() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  componentDidMount() {
    const { className } = this.props.component.props;
    if (className && className.includes("expanded")) {
      this.setState({ isExpanded: true });
    }
  }

  render() {
    const { title } = this.props.component.props;
    return (
      <div className="accordion-item">
        <button className="accordion-header" onClick={this.onHeaderClick}>
          <h1>{title.charAt(0).toUpperCase() + title.slice(1)}</h1>
          <MdDown
            size={24}
            color="rgba(255,255,255, .88)"
            className={this.state.isExpanded ? "chevron rotate" : "chevron"}
          />
        </button>

        {this.state.isExpanded && (
          <div className="accordion-content"> {this.props.component}</div>
        )}
      </div>
    );
  }
}

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/common/accordion/AccordionItem.js